import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, List } from "@/shared/ui";

export class Result extends AbstractStep {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Header className="bg-secondary-gradient text-white text-center">
					<div className="h3 font-weight-normal mt-2 mb-3">
						Már csak
						<br />
						<hr />
						<span className="display-3 display-bold d-inline-block mb-0 my-2">egy lépés</span>
						<hr />
						van hátra!
					</div>
				</Card.Header>
				<Card.Body className="d-flex flex-column">
					<div className="h4 text-center mt-auto">
						A részletes eredményeidet
						<br /> email-ben küldjük el
					</div>
					<List itemStyle="tick" variant="primary" className="mb-auto">
						<List.Item>Pontosan milyen védelmet kapsz ezen összegért? Hogyan működik?</List.Item>
						<List.Item>
							<strong>Milyen esetben kapod meg a kifizetést a biztosítótól?</strong>
						</List.Item>
						<List.Item>
							<strong>Szakértőink segítenek</strong> bármilyen felmerülő kérdésedben!
						</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy type="submit" icon={<FontAwesomeIcon icon={fasArrowRight} />}>
						Kérem az eredményeimet
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
